import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { CreateCollectionModal } from './create-collection-modal';
import { useProspectCollections } from '../../../hooks/use-prospect-collections';

const CreateCollectionButton = () => {
    const { createProspectCollection, prospectCollections } = useProspectCollections();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                variant="contained"
                disableElevation
                sx={{
                    width: 'fit-content',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    backgroundColor: '#6A76FB',
                    minHeight: '40px',
                    maxHeight: '40px',
                    minWidth: '123px',
                    transition: 'background-color 0.3s, transform 0.3s',
                    ':hover': {
                        backgroundColor: '#838dfc',
                    },
                }}
                onClick={handleOpen}
            >
                <Typography
                    component={'span'}
                    sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: '21px',
                        color: 'white',
                        transition: 'color 0.3s',
                    }}
                >
                    Create New Collection
                </Typography>
            </Button>
            <CreateCollectionModal
                open={open}
                onClose={handleClose}
                onSubmit={createProspectCollection}
                invalidNames={prospectCollections.map((pc) => pc.name)}
            />
        </>
    );
};

export default CreateCollectionButton;
